import React from 'react';
import ViewAdminSchedules from '../ViewAdminSchedules';

const ScheduleByStudentPage = () => <ViewAdminSchedules scheduleType="student" />;

export default ScheduleByStudentPage;
